<template>
  <div id="app">
    <Toasts/>
    <BuySell  v-if="$store.state.buysell">
    </BuySell>
    <router-view/>
  </div>
</template>

<script>
import Toasts from '@/components/toast/Toasts.vue'
import BuySell from '@/components/order/BuySell'
import axios from 'axios'
import router from './router'
import { refresh } from '@/service/restService'

// Store the refresh promise to prevent parallel calls
let refreshPromise = null
axios.interceptors.request.use((config) => {
  var token = localStorage.getItem('token')
  if (token) { config.headers.Authorization = `Bearer ` + token }
  return config
})

axios.interceptors.response.use(
  (response) => {
    // Handle the response here
    return response
  },
  async (error) => {
    // Handle errors here
    if (error.response && error.response.status === 403) {
      const refreshToken = localStorage.getItem('refreshToken')
      const expiry = localStorage.getItem('expiryEpoch')

      if (refreshToken && isTokenExpired(expiry)) {
        // If there's no ongoing refresh, create a new one
        if (!refreshPromise) {
          refreshPromise = refresh({ token: refreshToken, expiryEpoch: 0 })
            .then((response) => {
              localStorage.setItem('token', response.data.token)
              localStorage.setItem('expiryEpoch', response.data.expiryEpoch)
              // Reload the page to apply the new token
              router.go(0)
              return response
            })
            .catch((err) => {
              router.push('/signin')
              throw err
            })
            .finally(() => {
              // Clear the promise after completion
              refreshPromise = null
            })
        }

        try {
          // Wait for the ongoing refresh to complete
          await refreshPromise
          // Do not retry the original request
          return Promise.reject(error)
        } catch (err) {
          return Promise.reject(error)
        }
      } else {
        router.push('/signin')
      }
    }
    return Promise.reject(error)
  }
)

router.afterEach((to, from) => {
  if (from.name && (to.name === 'signin')) {
    window.location.reload()
  }
  if (from.name && (to.name === 'signup')) {
    window.location.reload()
  }
})

function isTokenExpired (expiredEpoch) {
  // Get current Unix timestamp in seconds
  const currentEpoch = Math.floor(Date.now() / 1000)

  // Check if expiration exists and compare
  if (expiredEpoch && !isNaN(expiredEpoch)) {
    return currentEpoch > parseInt(expiredEpoch, 10)
  }

  // Return true if no expiration is set (treat as expired)
  return true
}

export default {
  name: 'App',
  data () {
    return {
      socket: null,
      timer: null
    }
  },
  components: {
    Toasts,
    BuySell
  },
  methods: {
  },
  mounted () {

  },
  created () {
    const darkMode = localStorage.getItem('darkMode') === 'true'
    document.documentElement.setAttribute('data-bs-theme', darkMode ? 'dark' : 'light')
  }
}
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Register the service worker
    navigator.serviceWorker.register('/service-worker.js').then(
      (registration) => {
        console.log('Service Worker registered:', registration)

        // Optional: Handle updates to the service worker
        registration.onupdatefound = () => {
          const installingWorker = registration.installing
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                console.log('New content is available; please refresh.')
                // Optionally, notify the user or trigger a refresh
                window.location.reload()
              } else {
                console.log('Content is cached for offline use.')
              }
            }
          }
        }
      },
      (error) => {
        console.log('Service Worker registration failed:', error)
      }
    )
  })
}

</script>

<style scoped>
#app {
  font-family:  sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--bs-body-color);
}
.center-screen {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;

}
/* Reset defaults */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body, #app {
    width: 100%;
    min-height: 100vh; /* Allow content to expand beyond viewport */
    overflow-y: auto; /* Enable vertical scrolling */
    overflow-x: hidden; /* Prevent horizontal scrolling */
    background-color: var(--bs-body-bg); /* Use Bootstrap CSS variable for theme support */
    color: var(--bs-body-color);
}

.app-container {
    width: 100%;
    min-height: 100vh; /* Minimum height, allows expansion */
    max-width: 100vw; /* Prevent overflow */
    background-color: var(--bs-body-bg);
}

/* Ensure sections adapt to content */
.content-section {
    width: 100%;
    height: auto; /* Let content determine height */
    padding: 16px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue